import React from "react";
// import BaseIcon from "../../../../../components/svg_icons/BaseIcon";
// import "../../../../../css/pages/ca_pages/teams/tasks_model/TaskStatsCards.css"
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const CalendarStatsCards = ({ stats }) => {
    const cards = [
        {
            title: "Today's Tasks",
            value: stats?.todayTasks ?? 0,
            color: "#2563eb",
            icon: "calendar",
            subText: "Due today",
        },
        {
            title: "This Week",
            value: stats?.weekTasks ?? 0,
            color: "#10b981",
            icon: "calendar",
            subText: "Tasks due this week",
        },
        {
            title: "Overdue",
            value: stats?.overdueTasks ?? 0,
            color: "#ef4444",
            icon: "alert",
            subText: "Need attention",
        },
        {
            title: "Calendar Tasks",
            value: (stats?.todayTasks ?? 0) + (stats?.weekTasks ?? 0),
            color: "#8b5cf6",
            icon: "tasks",
            subText: "Current calendar workload",
        },
    ];

    return (
        // <div className="stats-grid">
        //     {cards.map((card) => (
        //         <div
        //             key={card.title}
        //             className="dashboard-stat-card"
        //             style={{ borderTop: `4px solid ${card.color}` }}
        //         >
        //             <div className="dashboard-stat-header">
        //                 <div
        //                     className="dashboard-stat-icon"
        //                     style={{
        //                         background: `${card.color}15`,
        //                         color: card.color,
        //                     }}
        //                 >
        //                     <BaseIcon name={card.icon} />
        //                 </div>

        //                 <span className="dashboard-stat-title">
        //                     {card.title}
        //                 </span>
        //             </div>

        //             <h2>{card.value}</h2>

        //             <p>{card.subText}</p>
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards } />
    );
};

export default CalendarStatsCards;
